<template xmlns="http://www.w3.org/1999/html">
  <loader-content :ref="(el: any) => loader = el">
  <div class="d-flex flex-column email-login">
    <div class="text-center">
      <h1>{{ $t('check_your_email')}}</h1>
    </div>
    <div class="text-center d-flex justify-content-center">
      <div class="mail-icon">
        <SvgIcon icon="mail"></SvgIcon>
      </div>
    </div>
    <div class="text-center">
      <span class="info">{{ state.error ? $t('notifications.verification_link_invalid') : $t('verifying_email') }}</span>
    </div>
    <div class="text-center" v-if="state.error">
      <router-link :to="{name:'emailLogin'}"><span class="register-here">{{$t('log_in')}}</span></router-link>
    </div>
  </div>
  </loader-content>
</template>
<script lang="ts" setup>
import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import {useRoute} from "vue-router";
import LoaderContent from "@/components/LoaderContent.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import {tryOpenApp} from "@/service/appDeepLink";

const state = reactive({
  error: false as boolean,
});

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore()
const route = useRoute()
const notification = useNotification()

onMounted(async () => {
  loader.value?.load(async () => {
    const urlToken = route.params.token as string
    if (await tryOpenApp(`verify-email/${urlToken}`)) {
      return
    }
    try {
      const token = await api.call.token.verifyEmail(urlToken)
      notification.notify({type: 'success', title: $t('notifications.email_verified'), duration: 1500})
      await store.dispatch('authenticate', token)
      window.location.href = '/'
    } catch (e) {
      state.error = true
    }
  });
})

</script>
